export const orderOperationMixin = {
  methods: {
    isBelongToIssuingFirm(order) {
      return (
        this.$store.state.Auth.user.firm.id == order.contract.contractee_firm_id
      );
    },
    isBelongToContractorFirm(order) {
      return (
        this.$store.state.Auth.user.firm.id == order.contract.contractor_firm_id
      );
    },
    canIssuingFirmUserUpdateOperation(order, operation) {
      return this.isBelongToIssuingFirm(order) && !operation.operationId;
      // 2023-03-09 - contractee firm users can update operation until activity_code_id and asset_id are populated
      // In the future, this will be controlled by operation->status
      // return (
      //   this.isBelongToIssuingFirm(order) &&
      //   (!operation.activityCode || !operation.asset)
      // );
    },
    canInspect(order, operation) {
      return (
        operation.activityCode &&
        (operation.activityCode.group || "").includes("-INSP") &&
        this.isBelongToContractorFirm(order)
      );
    },
    inspect(order, operation, hotspot = false) {
      let route = this.$router.resolve({
        // name: "form-disambiguation",
        // query: {
        //   form_type_code: operation.activityCode
        //     ? operation.activityCode.code
        //     : undefined,
        //   order_id: order.id,
        //   operation_id: operation.id,
        //   asset_id: operation.asset ? operation.asset.id : undefined,
        //   hotspot: hotspot ? 1 : 0
        // },
        name: "formio",
        query: {
          contract_id: order.contract_id,
          form_type_code: operation.activityCode ? operation.activityCode.code : undefined,
          //order_operation_id: operation.id,
          model_type: "order_operations",
          model_id: operation.id,
          // form_id: "new",
          // order_id: order.id,
          // asset_id: operation.asset ? operation.asset.id : undefined,
          // hotspot: hotspot ? 1 : 0
        },
      });
      window.open(route.href, "_blank");
    },
    viewForm(order, operation) {
      let route = null;
      if (this.isBelongToContractorFirm(order)) {
        route = this.$router.resolve({
          // name: "form-edit",
          // params: {
          //   id: operation.form.id
          // },
          name: "formio",
          query: {
            // form_type_code: operation.form.formType.code,
            form_id: operation.form.id
          },
        });
      } else {
        route = this.$router.resolve({
          // name: "form-show",
          // params: {
          //   id: operation.form.id
          // },
          name: "formio",
          query: {
            // form_type_code: operation.form.formType.code,
            form_id: operation.form.id
          },
        });
      }
      window.open(route.href, "_blank");
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/Order/mixins/orderOperationMixin.js